import {
  aDeleteCustomMatchListColumn,
  mockDeleteCustomMatchListColumnOperationMutation,
} from '__generated__';
import { delay, HttpResponse } from 'msw';

export const deleteCustomMatchListColumnOperationResponse = {
  __typename: 'Mutation' as const,
  deleteCustomMatchListColumn: aDeleteCustomMatchListColumn(),
};

export const handlers = [
  mockDeleteCustomMatchListColumnOperationMutation(
    async ({ query: _query, variables: _variables }) => {
      await delay(1500);
      return HttpResponse.json({
        data: {
          ...deleteCustomMatchListColumnOperationResponse,
        },
      });
    }
  ),
];
